import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const Credo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [credo, setCredo] = useState("");

  const isEditable = pathname.split("/").includes("edit");
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  const saveCredo = async (e) => {
    e.preventDefault();

    if (!credo) {
      toastr.error("Please fill the Credo");
      return;
    }

    const payload = {
      statement: credo,
      progress: 100,
    };

    try {

      const prevMessagePage = localStorage.getItem("prevMessagePage") === "true";
      if (prevMessagePage) {
        navigate("/message-page")
      } else {
        navigate("/onboarding-driver");
      }
      const res = await apiServiceHandler("POST", "api/credo", payload);
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  useEffect(() => {
      const fetchCredo = async () => {
        try {
          const res = await apiServiceHandler("GET", "api/credo", {});
          if (res.status) {
            setCredo(res.data.statement);
          }
        } catch (error) {
          console.log("Failed to fetch data")
        }
      };
      fetchCredo();
  }, []);

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="credo-heading">CREDO</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+17+Reading+Your+Credo.mp4"
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <textarea
                  type="text"
                  className="credo-input"
                  ref={textAreaRef}
                  value={credo}
                  onChange={(e) => setCredo(e.target.value)}
                />

                <div
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={saveCredo}
                  >
                    <span className="driver-button__label">
                      {isEditable ? "UPDATE" : "SAVE"}
                    </span>
                  </button>
                  <div
                    style={{
                      marginTop: "2rem",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate('/onboarding-driver')}
                  >
                    skip
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Credo;
